<template>
  <div class="infoCenter_notice">
    <div class="title">
      消息中心
      <p></p>
    </div>
    <div class="content" v-for="(item,i) in noticeList" :key="i">
      <div class="content_title">
        <span class="year">{{ item.title }}</span>
        <span class="delete" @click="deleteNotice(item.id)">删除</span>
        <span class="time">{{ item.createDate }}</span>
      </div>
      <div class="content_text">{{ item.content }}</div>
    </div>

    <div class="fenye">
      <el-pagination
        background
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        :total="infomationList.length"
        layout=" slot "
      >
        <span style="color: #7a7a7a;font-size: 12px;margin-right: 15px;line-height: 36px;">
          共
          {{ totalIndex }}
          页
        </span>
        <el-button
          :disabled="firstPageBtnDisabled"
          class="first-pager"
          @click="toFirstPage"
        ><< &nbsp;首页</el-button>
      </el-pagination>
      <el-pagination
        background
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-size="pageSize"
        :total="infomationList.length"
        layout="pager, next, slot, jumper "
      >
        <el-button
          :disabled="lastPageBtnDisabled"
          class="first-pager"
          @click="toLastPage"
        >末页 &nbsp;>></el-button>
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      infomationList: [],
      pageSize: 5, // 每页条数
      pageIndex: 1, // 当前页
      totalPage: 0, // 总条数
      firstPageBtnDisabled: true,
      lastPageBtnDisabled: false,
      totalIndex: 0,
      noticeList: [], // 消息列表
    };
  },
  mounted() {
    if (this.infomationList.length > 0) {
      this.firstPageBtnDisabled = false;
      this.lastPageBtnDisabled = false;
    } else {
      this.firstPageBtnDisabled = true;
      this.lastPageBtnDisabled = true;
    }
    this.totalIndex = Math.ceil(this.infomationList.length / this.pageSize);
    this.getAllNotice();
  },
  methods: {
    // 所有消息
    getAllNotice() {
      this.$http({
        url: "getNoticeByAccId",
        method: "get",
      })
        .then(({ data }) => {
          let { code, noticeByAccIdList } = data;
          if (code === 0) {
            this.noticeList = noticeByAccIdList;
          } else {
            this.$message.error("登录失效，请重新登录");
            this.$router.push("/login");
          }
        })
        .catch((err) => {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/login");
        });
    },
    // 删除消息
    deleteNotice(id) {
      this.$confirm("确认删除当前消息？").then(() => {
        this.$http({
          url: "deleteNoticeById",
          method: "post",
          params: {
            noticeId: id,
          },
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success("删除成功！");
              this.getAllNotice();
            }
          })
          .catch((_) => {});
      });
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.firstPageBtnDisabled = val === 1 ? true : false;
      this.lastPageBtnDisabled = val === this.lastPageNum ? true : false;
    },
    // 首页
    toFirstPage() {
      this.pageIndex = 1;
      this.lastPageBtnDisabled = false;
      this.firstPageBtnDisabled = true;
    },
    // 尾页
    toLastPage() {
      this.pageIndex = this.lastPageNum;
      this.firstPageBtnDisabled = false;
      this.lastPageBtnDisabled = true;
    },
  },
};
</script>
<style lang="scss">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2878ff;
}
.el-message-box__btns button:nth-child(2) {
  background-color: #143372;
  border-color: #143372;
}
.el-message-box__btns button:nth-child(1) {
  &:hover {
    background-color: #ffffff;
    color: #606266;
    border-color: #dcdfe6;
  }
}
.infoCenter_notice {
  .fenye {
    height: 32px;
    text-align: center;
    margin-top: 57px;
    margin-left: 32%;
    .el-pagination {
      width: 121px;
      float: left;
      .el-pager {
        height: 32px;
        li:not(.disabled).active {
          background-color: #2878ff;
          color: #ffffff;
          &:hover {
            color: #ffffff;
          }
        }
        .number:hover {
          color: #9ea4b9;
        }
      }
      .btn-next,
      .number {
        width: 32px;
        height: 32px;
        border: 1px solid #e6e6e6;
        border-radius: 5px;
        line-height: 32px;
        color: #9ea4b9;
        background-color: #ffffff;
      }
      .el-pagination__jump {
        height: 32px;
        line-height: 32px;
        margin-left: 15px;
      }
    }
    .first-pager {
      width: 74px;
      height: 32px;
      border: 1px solid #e6e6e6;
      border-radius: 5px;
      text-align: center;
      color: #9ea4b9;
      &:focus,
      &:hover {
        background-color: #ffffff;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.infoCenter_notice {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 10px;
    p {
      width: 70px;
      height: 2px;
      background-color: #143372;
      position: absolute;
      bottom: -1px;
      left: 30px;
    }
  }
  .content {
    width: 860px;
    height: 142px;
    margin: 20px 31px 0 29px;
    border: 1px solid #e5e5e5;
    .content_title {
      width: 100%;
      height: 52px;
      background-color: #f2f2f2;
      line-height: 52px;
      border-bottom: 1px solid #e5e5e5;
      text-indent: 20px;
      .year {
        float: left;
        font-size: 16px;
        color: #333333;
      }
      .delete,
      .time {
        float: right;
        font-size: 14px;
        color: #333333;
      }
      .time {
        opacity: 0.5;
      }
      .delete {
        margin-right: 18px;
        cursor: pointer;
      }
    }
    .content_text {
      width: 815px;
      height: 40px;
      padding: 20px 30px 20px 17px;
      line-height: 27px;
      font-size: 12px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>